import { footer, TIKTOK_URL } from "@/content/copy";
import { Owl } from "./primitives";

export const Footer = () => (
  <footer data-testid="footer-section" className="border-t ph-rule">
    <div className="ph-container py-12 sm:py-16 flex flex-col md:flex-row md:items-end justify-between gap-8">
      <div className="flex items-center gap-4">
        <Owl alt="Philosophiles owl" className="h-14 w-14 object-contain" />
        <div>
          <p className="font-display text-2xl">Philosophiles</p>
          <p data-testid="footer-signoff-text" className="font-display italic text-lg opacity-90">{footer.signoff}</p>
        </div>
      </div>
      <a href={TIKTOK_URL} target="_blank" rel="noopener noreferrer" data-testid="footer-tiktok-link" className="ph-navlink text-base self-start md:self-auto">
        {footer.link}<span className="sr-only"> (opens in a new tab)</span>
      </a>
    </div>
  </footer>
);
